module.exports = __webpack_public_path__ + "static/media/synth_07.dfa09041.mp3";